import React from "react";

import { FileText } from "lucide-react";

import { Button } from "~/components/ui/button";
import { EmptyState } from "~/components/ui/empty-state";
import { TableSkeleton } from "~/components/ui/skeletons";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "~/components/ui/table";
import { formatCurrency, formatDate } from "~/utils/helpers";

interface Payment {
  id: number;
  salesRequestId: string;
  amount: number;
  paymentMethod: string;
  txInternalId: string | null;
  createdAt: string;
}

interface ClientPaymentsSectionProps {
  payments: Payment[];
  loading: boolean;
  onViewOrder: (salesRequestId: string) => void;
}

export const ClientPaymentsSection: React.FC<ClientPaymentsSectionProps> = ({
  payments,
  loading,
  onViewOrder,
}) => {
  return (
    <div>
      <h3 className="mb-3 text-base font-semibold">Pagos del Cliente</h3>
      {loading ? (
        <TableSkeleton rows={4} columns={6} />
      ) : payments.length > 0 ? (
        <div className="overflow-hidden rounded-md border">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow>
                <TableHead>Fecha</TableHead>
                <TableHead>ID de Nota</TableHead>
                <TableHead>Método</TableHead>
                <TableHead>Referencia</TableHead>
                <TableHead className="text-right">Monto</TableHead>
                <TableHead className="text-right">Acciones</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {payments.map((payment, index) => (
                <TableRow
                  key={payment.id}
                  className="duration-300 animate-in fade-in-0 slide-in-from-top-1 fill-mode-both hover:bg-muted/30"
                  style={{ animationDelay: `${Math.min(index * 40, 400)}ms` }}
                >
                  <TableCell>{formatDate(payment.createdAt)}</TableCell>
                  <TableCell>{payment.salesRequestId}</TableCell>
                  <TableCell>{payment.paymentMethod}</TableCell>
                  <TableCell>{payment.txInternalId || "—"}</TableCell>
                  <TableCell className="text-right font-medium">
                    {formatCurrency(payment.amount)}
                  </TableCell>
                  <TableCell className="text-right">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => onViewOrder(payment.salesRequestId)}
                    >
                      <FileText className="mr-2 h-4 w-4" />
                      Ver nota de venta
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <EmptyState
          title="No hay pagos registrados"
          description="Los pagos verificados del cliente aparecerán aquí."
        />
      )}
    </div>
  );
};
